import React, { useEffect, useState } from 'react'
import DashboardLink from '../../../components/others/DashboardLink'
import { sharedAccessService } from '../../../store/services/ServiceSharedAccess'
import eventBus from '../../../store/services/EventBus'

const RequestedSharedAccess = ({ user, page, setHasActiveSharedAccess }) => {
    const [stats, setStats] = useState(null)

    const fetchSharedAccessStats = async () => {
        const statsResponse = await sharedAccessService.getSharedAccessRequestsStats();

        if (statsResponse?.status === 200) {
            setStats(statsResponse.response);
            setHasActiveSharedAccess(statsResponse.response.approved > 0);
        }
    }

    useEffect(() => {
        fetchSharedAccessStats();

        // Subscribe to shared access updates
        const unsubscribe = eventBus.subscribe('sharedAccessUpdate', () => {
            fetchSharedAccessStats();
        });

        // Cleanup subscription on component unmount
        return () => {
            unsubscribe();
        };
        // eslint-disable-next-line
    }, []);

    // Don't render anything if there are no pending requests
    if (!stats?.pending) {
        return null;
    }

    return (
        <>
            {(user.role === 'Provider') && (
                <DashboardLink
                    title={`Žiadosť o prístup (${stats.pending})`}
                    task={(e) => page(e, 'profile/?tab=shared-access')}
                    role={'Provider'}
                    iconName="share alternate"
                    address="profile/?tab=shared-access"
                />
            )}
        </>
    )
}

export default RequestedSharedAccess